import { axiosInstance } from "@/services/axiosInstance";

export const MerchantCommissioningResource = {
  getLista: parametros => {
    return axiosInstance.get("v1/merchantcommissioning", {
      params: parametros
    });
  },
  save: parametros => {
    return axiosInstance.post("v1/merchantcommissioning",parametros)
  }
};